import { Button } from '@customerio/pluma-components/react';
import clsx from 'clsx';
import { FlexMark, leadingMarkButton } from '@/components/flex-mark';
import * as styles from './segments-addon-button.css';

type SegmentsAddonButtonProps = {
  onClick: () => void;
  /** Inside a caution banner: a plain secondary button with the mark in the banner's colours. */
  tone?: 'caution';
};

/**
 * The Credits Lifecycle prototype's "Flex add-on" tag, offered at the data-driven segment cap. It is a small Pluma
 * Button because Pluma's Badge and Tag are not actions.
 */
export function SegmentsAddonButton({ onClick, tone }: SegmentsAddonButtonProps) {
  const isCaution = tone === 'caution';

  return (
    <Button
      className={isCaution ? leadingMarkButton : clsx(styles.flexTag, leadingMarkButton)}
      variant={isCaution ? 'secondary' : undefined}
      size="sm"
      elementBefore={<FlexMark tone={tone} />}
      onClick={onClick}
    >
      Flex add-on
    </Button>
  );
}
